export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/pages/dashboard/Dashboard.vue"),
    meta: {
      hasPermission: true,
    },
  },
  {
    path: "/profile",
    component: () => import("@/views/pages/profile/Profile.vue"),

    children: [
      {
        path: "",
        name: "profile",
        component: () =>
          import("@/views/pages/profile/profile-detail/ProfileDetail.vue"),
      },

      {
        path: "road-map",
        name: "profile-road-map",
        component: () =>
          import("@/views/pages/profile/profile-road-map/ProfileRoadMap.vue"),
      },
      {
        path: "exercises",
        name: "profile-exercises",
        component: () =>
          import(
            "@/views/pages/profile/profile-exercises/profileExercises.vue"
          ),
      },
      {
        path: "shop",
        name: "profile-shop",
        component: () => import("@/views/pages/shop-list/ShopList.vue"),
      },
      {
        path: "edit",
        name: "profile-edit",
        component: () =>
          import("@/views/pages/profile/profile-edit/ProfileEdit.vue"),
      },
      {
        path: "courses",
        name: "profile-courses",
        component: () =>
          import("@/views/pages/profile/profile-courses/ProfileCourses.vue"),
      },
      {
        path: "audit-logs",
        name: "profile-audit-logs",
        component: () =>
          import(
            "@/views/pages/profile/profile-audit-logs/ProfileAuditLogs.vue"
          ),
        meta: {
          hasPermission: true,
        },
      },
      {
        path: "invoices",
        name: "profile-paid-items",
        component: () =>
          import(
            "@/views/pages/profile/profile-paid-items/ProfilePaidItems.vue"
          ),
      },
      {
        path: "devices",
        name: "profile-devices",
        component: () =>
          import("@/views/pages/profile/profile-devices/ProfileDevices.vue"),
      },
      {
        path: "penalties",
        name: "profile-penalties",
        component: () =>
          import(
            "@/views/pages/profile/profile-penalties/ProfilePenalties.vue"
          ),
      },
      {
        path: "transactions",
        name: "profile-transactions",
        component: () =>
          import(
            "@/views/pages/profile/profile-transactions/ProfileTransactions.vue"
          ),
      },
    ],
  },
];
